
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

interface ResumeFormAlertsProps {
  apiError: string | null;
  isDuplicateResume: boolean;
}

const ResumeFormAlerts = ({ apiError, isDuplicateResume }: ResumeFormAlertsProps) => {
  if (!apiError && !isDuplicateResume) return null;

  return (
    <>
      {apiError && (
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Error</AlertTitle>
          <AlertDescription>
            {apiError}
          </AlertDescription>
        </Alert>
      )}
      
      {isDuplicateResume && (
        <Alert>
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Resume Already Exists</AlertTitle>
          <AlertDescription>
            You've already uploaded this resume before. You can continue to optimize it for a different job.
          </AlertDescription>
        </Alert>
      )}
    </>
  );
};

export default ResumeFormAlerts;
